"use client";

import { Classic } from "loading-dev";
import { AnimatePresence, m } from "motion/react";
import type { ReactNode } from "react";
import { SPRING_FAST } from "@/lib/motion";
import { cn } from "@/lib/utils";

const TRAVEL = 32;

interface PendingLabelProps {
  children: ReactNode;
  className?: string;
  labelKey?: string;
  pending: boolean;
  spinnerClassName?: string;
}

export function PendingLabel({
  children,
  className,
  labelKey = "label",
  pending,
  spinnerClassName,
}: PendingLabelProps) {
  return (
    <AnimatePresence initial={false} mode="popLayout">
      {pending ? (
        <m.span
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center"
          exit={{ opacity: 0, y: TRAVEL }}
          initial={{ opacity: 0, y: -TRAVEL }}
          key="spinner"
          transition={SPRING_FAST}
        >
          <Classic className={spinnerClassName} size={16} />
        </m.span>
      ) : (
        <m.span
          animate={{ opacity: 1, y: 0 }}
          className={cn("flex items-center", className)}
          exit={{ opacity: 0, y: TRAVEL }}
          initial={{ opacity: 0, y: -TRAVEL }}
          key={labelKey}
          transition={SPRING_FAST}
        >
          {children}
        </m.span>
      )}
    </AnimatePresence>
  );
}
